import { Icon } from "@material-ui/core";
import Toolbar from "Components/Common/Toolbar/Toolbar";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IApplicationState } from "Store/Store";
import { ITaskAction } from "Store/Tasks/TaskAction";
import i18n from "Translations/i18n";
import ExportTasksPopup from "./ExportTasksPopup/ExportTasksPopup";
import styles from "./TaskTemplateBlockOverviewHeader.scss";

const taskTemplateAction = ServiceProvider.get<ITaskAction>(Types.ITaskAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    exportTasksAsync: (fromDate: Date, toDate: Date) =>
        dispatch(taskTemplateAction.exportTasksAsync(fromDate, toDate)),
});

const mapStateToProps = (state: IApplicationState) => ({
    taskState: state.taskState
});

interface IProps {
    exportTasksAsync: (fromDate: Date, toDate: Date) => Action;
}

interface IState {
    showExportPopup: boolean;
}

export class TaskTemplateBlockOverviewHeader extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showExportPopup: false
        };

        this.export = this.export.bind(this);
    }

    public export() {
        this.setState({ showExportPopup: true });
    }

    public exportTasksPopupChanged(state: { shouldShow: boolean }) {
        this.setState({ showExportPopup: state.shouldShow });
    }
    
    public render() {
        return (
            <div className={styles.taskTemplateOverviewHeader}>
                <ExportTasksPopup shouldShow={this.state.showExportPopup} onChange={(state) => this.exportTasksPopupChanged(state)} />
                <Toolbar>
                    <button onClick={this.export} id="btn">
                        <Icon>save_alt</Icon>
                        {i18n.t("tasks.exportTasks")}
                    </button>
                    <RouterLink to="/tasktemplates/list/arrange" type={RouterLinkType.default}>
                        <button id="btnArrangeTasks">
                            <Icon>drag_handle</Icon>
                            {i18n.t("tasks.arrangeTasks")}
                        </button>
                    </RouterLink>
                    <RouterLink to="/tasktemplates/new" type={RouterLinkType.default}>
                        <button id="btnCreateNewTask">
                            <Icon>add</Icon>
                            {i18n.t("tasks.createNewTask")}
                        </button>
                    </RouterLink>
                </Toolbar>
                <h1>{i18n.t("tasks.blockOverviewTitle")}</h1>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplateBlockOverviewHeader);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockOverviewHeader/TaskTemplateBlockOverviewHeader.tsx